import "./App.css";
import { Routes, Route } from "react-router-dom";
import ReportContainer from "./containers/ReportContainer";
import { AppProvider } from "./context/AppContext";
import { CssBaseline } from "@mui/material";
function App() {
	return (
		<AppProvider>
			<CssBaseline />
			<Routes>
				<Route path="/report/view" element={<ReportContainer />} />
			</Routes>
		</AppProvider>
	);
}

export default App;
